import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport,WizModal} = component_tool

class ApplicationManageInfo extends WizContainer {
  componentName = 'applicationManageInfo'

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '应用服务名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '编号',
        field: 'code',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '所属组织',
        field: 'orgName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '来源',
        field: 'sourceType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '状态',
        field: 'status',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['sourceType'] == 0 ? e['sourceType'] = "新培训平台" : e['sourceType'] = "第三方系统"
        e['status'] == 0 ? e['status'] = "禁用" : e['status'] = "启用"
      })
      WizBrowserExport({
        title: '应用服务信息',
        sheetName: '应用服务信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '应用服务信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig({
      _btnFun: (e) => {
        if(e && e.rows && e.rows.length && e.rows.length === 1){
          let record = {}
          e.rows.forEach(d => {
            record = d
          })
          this.jumpPage('push','/application/applicationManage/applicationManageToColumnDetail',record)
        } else {
          WizModal.confirm({
            title: '请选择一条数据',
            onOk: () => {},
            onCancel() {}
          })
        }
      }
    })
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile,
        enable: this._handleCMD
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ApplicationManageInfo);
